import reduce from '../utils/reducers'
import d from '../utils/directives'
import Q_ from '../query'

export default function($api) {
  return {
    // documents to fetch on load
    fetchOnLoad(types) {
      return $api.get({
        query: Q_(d.any.type(types)),
        pageSize: types.length
      })
      .then(({ results }) => Promise.resolve(results.map(
        ({ type, data }) => ({ view: type, data: reduce.content(data[type]) })
      )))
    },

    // fetch author data
    fetchAuthors() {
      return $api.get({
        query: Q_(d.at.type('author')),
        pageSize: 100
      })
      .then(({ results }) => Promise.resolve(results.map(result => {
        return {
          id: result.id,
          uid: result.uid,
          ...reduce.content(result.data[result.type])
        }
      })))
    }
  }
}



// WEBPACK FOOTER //
// ./src/api/actions/general.js